import { render, staticRenderFns } from "./AuthError.vue?vue&type=template&id=22f1ceb8&"
var script = {}
import style0 from "./AuthError.vue?vue&type=style&index=0&id=22f1ceb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports